<form class="form-popup" [formGroup]="formGroup">
 <div class="modal-body">
    <mat-form-field appearance="fill">
      <textarea matInput rows="6" formControlName="rejectionComment" style="width:400px;">
      </textarea>
    </mat-form-field>
    <div>
      Send Email:&nbsp;<mat-checkbox formControlName="sendRejectEmail"></mat-checkbox>
    </div>
  </div>
</form>
